import { useEffect } from 'react';
import { useMedia } from 'react-use';
import { Toaster } from 'sonner';

import { breakpoints } from '@/styles/util';

const toasterGap = { mobile: 16, desktop: 24 };
const toasterOffsetDesktop = { right: 40, bottom: 24 };
const toasterOffsetMobile = { right: 16, bottom: 16 };

export const appToasterVars = {
  gap: '--app-toaster-gap',
  bottomOffset: '--app-toaster-bottom-offset',
};

export const AppToaster = () => {
  const isMobile = useMedia(breakpoints.mobile, false);

  const gap = isMobile ? toasterGap.mobile : toasterGap.desktop;
  // Update toaster-gap and toaster-offset CSS var on breakpoint / page change
  useEffect(() => {
    document.documentElement.style.setProperty(appToasterVars.gap, `${gap}px`);

    const offset = isMobile ? toasterOffsetMobile : toasterOffsetDesktop;
    document.documentElement.style.setProperty(appToasterVars.bottomOffset, `${offset.bottom}px`);
  }, [gap, isMobile]);

  return (
    <Toaster
      position="bottom-right"
      offset={toasterOffsetDesktop}
      mobileOffset={toasterOffsetMobile}
      gap={gap}
      expand={true}
      richColors={true}
    />
  );
};
